import React, { useState } from "react";
import { logo } from "../../assets";
import axiosLamApi from "../../library/axios-lam-api";
import { MySwal } from "../../library/swal";
import { runHospitalVerificationSetup } from "../../helpers/hospitalVerificationSetup";
import { FormVerificationManual, VersionInfoButton } from "../../components";
import Modal from "react-bootstrap/Modal";
import { IconRocket } from "@tabler/icons-react";
import { APP_VERSION } from "../../constants/appVersion";
import { notifyApiLoadError } from '../../helpers/notifyApiError';

const VerificationPage = () => {
  const [kodeVerifikasi, setkodeVerifikasi] = useState("");
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [showVerificationManual, setshowVerificationManual] = useState(false);

  const handleSubmit = () => {
    if (kodeVerifikasi.length === 0) {
      MySwal.fire({
        icon: "error",
        title: "Oops, Validasi Gagal!",
        text: "Kode Verifikasi tidak boleh kosong.",
      });
      return false;
    }

    setLoading(true);
    setDisabled(true);

    // fe post ke be untuk kode verifikasi
    const requestBody = {
      kodeVerifikasi: kodeVerifikasi,
    };

    axiosLamApi({
      url: "/auth/verifikasi",
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: requestBody,
    })
      .then(async (res) => {
        if (res?.data?.code === 200) {
          try {
            await runHospitalVerificationSetup(res.data.record);
          } catch (err) {
            notifyApiLoadError(err, 'pages/auth/verification.handleSubmit');
            setLoading(false);
            setDisabled(false);
          }
        } else {
          MySwal.fire({
            icon: "error",
            title: "Oops, Validasi Gagal",
            text: res?.data?.message || 'Permintaan tidak berhasil diproses. Silakan coba lagi.',
          });
          setLoading(false);
          setDisabled(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);

        if (err !== "") {
          console.log(err.message);

          MySwal.fire({
            icon: "error",
            title: "Bad Request!",
            text: "Parameter tidak lengkap.",
          });
        }
      });
  };

  return (
    <>
      {/*begin::Main*/}
      <div className="d-flex flex-column flex-root" style={{ marginTop: "3%" }}>
        {/*begin::Authentication - Password reset */}
        <div
          className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
        // style={{
        //   backgroundImage:
        //     "url(metronic/dist/assets/media/illustrations/dozzy-1/14.png",
        // }}
        >
          {/*begin::Content*/}
          <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-10">
            {/*begin::Logo*/}
            <a className="mb-10">
              <img alt="Logo" src={logo} className="h-60px" />
            </a>
            {/*end::Logo*/}
            {/*begin::Wrapper*/}
            <div className="bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
              <div className="card">
                <h3 className="card-title text-info">
                  *Form Verifikasi #SPEAK_VERSI_RS
                </h3>
                <div className="card-header card-header-stretch">
                  <div className="card-toolbar">
                    <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          data-bs-toggle="tab"
                          href="#kt_tab_pane_7"
                        >
                          Metode Online
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-bs-toggle="tab"
                          href="#kt_tab_pane_8"
                        >
                          Metode Offline
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-body">
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="kt_tab_pane_7"
                      role="tabpanel"
                    >
                      {/*begin::Form*/}
                      <form
                        className="form w-100"
                        noValidate="novalidate"
                        id="kt_password_reset_form"
                      >
                        {/*begin::Heading*/}
                        <div className="mb-5">
                          {/*begin::Link*/}
                          <div className="fw-bold fs-5">
                            Sebelum menggunakan #SPEAK_VERSI_RS, silakan kirim
                            <br></br>
                            Kode Verifikasi yang sudah kami kirimkan ke email
                            terdaftar.
                            <br></br>
                            <b style={{ color: "#E74C3C" }}>
                              Metode ini membutuhkan koneksi internet yang
                              stabil.
                            </b>
                            <br></br>
                            Untuk proses sinkronisasi data dari server kami.
                          </div>
                          {/*end::Link*/}
                        </div>
                        {/*begin::Heading*/}
                        {/*begin::Input group*/}
                        <div className="fv-row mb-5">
                          <label className="form-label fw-bolder text-gray-900 fs-6">
                            Kode Verifikasi
                          </label>
                          <input
                            className="form-control form-control-solid"
                            type="text"
                            autoComplete="off"
                            onChange={(e) => setkodeVerifikasi(e.target.value)}
                            value={kodeVerifikasi}
                            placeholder="******"
                          />
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Actions*/}
                        <div className="d-flex flex-wrap justify-content-center pb-lg-0">
                          <button
                            onClick={() => handleSubmit()}
                            type="button"
                            className="btn btn-lg btn-primary fw-bolder me-4"
                          >
                            <span
                              className="indicator-label"
                              disabled={disabled}
                            >
                              <IconRocket stroke={2} />{" "}
                              {loading === true ? "Mohon tunggu..." : "Submit"}
                            </span>
                          </button>
                        </div>
                        {/*end::Actions*/}
                      </form>
                      {/*end::Form*/}
                    </div>
                    <div
                      className="tab-pane fade"
                      id="kt_tab_pane_8"
                      role="tabpanel"
                    >
                      <div className="fw-bold fs-5">
                        Metode Offline ini mengharuskan Anda mengisi data
                        <br></br>
                        Profil Rumah Sakit & Narahubung secara manual.
                        <br></br>
                        <b style={{ color: "#E74C3C" }}>
                          Metode ini tidak membutuhkan koneksi internet.
                        </b>
                        <br></br>
                        Klik tombol di bawah ini untuk melanjutkan.
                        <br></br>
                        <div className="row justify-content-center mt-5">
                          <button
                            onClick={() => setshowVerificationManual(true)}
                            type="button"
                            className="btn btn-light-primary "
                          >
                            <IconRocket stroke={2} /> Lanjutkan
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*end::Wrapper*/}
          </div>
          {/*end::Content*/}
          {/*begin::Footer*/}
          <div className="d-flex flex-center flex-column-auto">
            {/*begin::Links*/}
            <div className="d-flex align-items-center fw-bold fs-6">
              {/* <a href="https://lam-kprs.id/" target='_blank' className="text-muted text-hover-primary px-2">2023© | LAM-KPRS</a> */}
              <small>
                Version: {APP_VERSION}
              </small>
            </div>
            {/*end::Links*/}
          </div>
          {/*end::Footer*/}
        </div>
        {/*end::Authentication - Password reset*/}
      </div>
      {/*end::Main*/}

      <VersionInfoButton />

      <Modal
        show={showVerificationManual}
        onHide={() => setshowVerificationManual(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Form Profil RS & Narahubung</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormVerificationManual
            close={() => setshowVerificationManual(false)}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VerificationPage;
